import * as React from "react";
import { ReactNode } from "react";

import { Classes } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";

interface WithLoaderProps {
  loading: boolean;
  loader?: ReactNode;
  children: ReactNode;
}

const DEFAULT_LOADER = (
  <Box className={Classes.SKELETON} height={48} width="100%" />
);

export function WithLoader({
  loading,
  loader = DEFAULT_LOADER,
  children,
}: WithLoaderProps): React.ReactElement {
  return <>{loading ? loader : children}</>;
}
